module.exports = __webpack_public_path__ + "assets/img/1.e2938115.png";